import styles from "../HealthChat.module.css";

export default function RecommendedScreen({ onBook, onTips, onTests , onBack}) {
  return (
    <div className={styles.recommendedScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.recommendedTitle}>Recommended Next Steps</div>

      <div className={styles.recommendedAdviceCard}>
        <div className={styles.recommendedAdviceIcon}>💡</div>
        <div>
          <div className={styles.recommendedAdviceHeading}>Advice</div>
          <div className={styles.recommendedAdviceText}>
            It's important to ease stress and stay hydrated. Consider relaxation
            techniques such as deep breathing and meditation.
          </div>
        </div>
      </div>

      <div className={styles.recommendedCareHeading}>
        Care Options{" "}
        <span className={styles.recommendedCareHint}>
          Select an option to continue
        </span>
      </div>

      <div className={styles.recommendedCareGrid}>
        <div className={styles.recommendedCareCard}>
          <div
            className={styles.recommendedCareImg}
            style={{ background: "#dceeff" }}
          >
            🧑‍⚕️
          </div>
          <div className={styles.recommendedCareCardTitle}>Book a Doctor</div>
          <div className={styles.recommendedCareCardDesc}>
            Schedule an appointment with a physician.
          </div>
          <button
            className={styles.recommendedCareBtn}
            style={{ background: "#132573" }}
            onClick={onBook}
          >
            Find a Doctor
          </button>
        </div>

        <div className={styles.recommendedCareCard}>
          <div
            className={styles.recommendedCareImg}
            style={{ background: "#d4edda" }}
          >
            🌿
          </div>
          <div className={styles.recommendedCareCardTitle}>Home Care Tips</div>
          <div className={styles.recommendedCareCardDesc}>
            Steps to manage your symptoms at home.
          </div>
          <button
            className={styles.recommendedCareBtn}
            style={{ background: "#2e7d32" }}
            onClick={onTips}
          >
            View Tips →
          </button>
        </div>

        <div className={styles.recommendedCareCard}>
          <div
            className={styles.recommendedCareImg}
            style={{ background: "#fff3e0" }}
          >
            🧪
          </div>
          <div className={styles.recommendedCareCardTitle}>Get Lab Tests</div>
          <div className={styles.recommendedCareCardDesc}>
            Order lab tests to check your health.
          </div>
          <button
            className={styles.recommendedCareBtn}
            style={{ background: "#e86f00" }}
            onClick={onTests}
          >
            Order Tests →
          </button>
        </div>
      </div>
    </div>
  );
}
